
import React, { Component, Fragment } from 'react'
import { Modal, ControlLabel, FormControl, Button, Row, Col } from 'react-bootstrap'
import { getParams, total0Recept, validateEmail, filterSearch, end_point, handleApprovedRedirect, mmddyyyyDateFormat, makeUniqueKey, instalment_field, getStatus, addStatus, applyOrganizationTheme, formatSessionDateLabel, sortProgramSessions } from './helper'
import { hoopstirServices } from './Leagues/servicesData'
import { initialValues, validationSchema } from './Leagues/formValidation'
import { ErrorMessage, Formik, Form, Field } from 'formik'
import HamburgerNavbar from './hamburgerNavbar'
import OrganizationBar from './organizationBar'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import {AccountHolderDetails} from './Leagues/accountHolderDetails'
import OrgDetails from './Leagues/orgDetails'
import PaymentDetails from './Leagues/paymentDetails'
import ProgramDetails from './EnrollmentFormComponents/programDetails'
import PriceBreakdown from './EnrollmentFormComponents/priceBreakdown'
import StripePaymentGateway from './enrollmentFormFunctions/StripePaymentGateway'
import ConvergePaymentGateway from './enrollmentFormFunctions/ConvergePaymentGateway'
import { LeagueEnrollmentForm } from './leagueEnrollmentForm'


var $ = require('jquery');

class LeagueEnrolment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admin_email: props.email,
      all_programs: [],
      all_leagues: [],
      attachments: [],
      checkFormik: false,
      coaches: [],
      coachOptions: [],
      confirm_spinner: false,
      continue_spinner: false,
      clubteamUser: false,
      current_user: null,
      dataReserve: [],
      DOB: null,  
      diffMailAddress: true,
      diffBankDetails: false,
      disabled: false,
      displayPaymentForm: false,
      EF1: false,
      EF1Submitted: false,
      endpoint: `${end_point()}/enrollment`,
      enrolHint: false,
      enrolTeamVisible: false,
      enrolInLeagues: getParams().extLeague === 'true' || !props.allowSelectPrograms ? true : false,
      instalments: [],
      instalment_number: 1,
      league: {},
      leagueOptions: [],
      leagues: [],
      loading: false,
      loginEndpoint: `${end_point('users')}/login`,
      multipleLeagues: null,
      newOrg: false,
      newToken: null,
      organization: {},
      organization_id: getParams().organization_id || localStorage.getItem("organization_id"),
      organization_name: getParams().organization_name?decodeURIComponent(getParams().organization_name):localStorage.getItem("organization_name"),
      paymentStatus: null,
      pay_spinner: false,
      priceElements: {},
      priceTotal: 0,
      pricingEndpoint: `${end_point()}/pricing`,
      pricingBreakdown: {},
      search: getParams().search || props.search,
      services: hoopstirServices,
      selected_leagues: [],
      selected_plan: {},
      select_class: "orange_background",
      showDetails: false,
      showPricingBreakdown: false,
      showHint: false,
      showWaiverModal: false,
      teamOptions: [],
      teams: {},
      token: getParams().jwt || props.token,
      tokenGenerator: end_point('payments'),
      transactionEndpoint: `${end_point('transactions')}/transactions`,
      transaction_id: null,
      waitlistInitialSignup: false,
      waitlistTransaction: null,
      overrideSelectedProgram: null,
      overrideShowDetails: false,
      overrideToken: null,
      onTxnUnverified: null,
      overrideHandleRefresh: props.overrideHandleRefresh,
      needsRevalidation: true,
    }
  }

  componentDidMount() {
    if (getParams().EF1) {
      this.setState({ loading: false })
      this.loadLeagueOptions()
    } else {
      $.ajax({
        headers: {
          "token": this.state.token,
          "organization_id": this.state.organization_id
        },
        method: "GET",
        dataType: "json",
        url: this.state.endpoint
      }).then(data => {
        this.setState({ loading: false })
        var leagues = []
        console.log('get enrollment all data:', data.message)
        applyOrganizationTheme({
          navbar_color: data.message.organization[0].navbar_color || '#5563b8',
          navbar_text_color: data.message.organization[0].navbar_text_color || '#ffffff',
        })
        
        data.message.programs.forEach(league => {
          if (league.type === "rep league" || league.type === "tournament") {
            leagues.push(league)
          }
          return leagues
        })
        
        this.haveEnrolmentData(leagues)
        this.loadLeagueOptions()
        this.setState({
          current_user: data.message.parent,
          all_leagues: leagues,
          all_programs: data.message.programs,
          league: data.message.organization[0],
          overrideShowDetails: this.props.overrideShowDetails,
          overrideSelectedProgram: this.props.overrideSelectedProgram,
          token: this.props.overrideToken,
          onTxnUnverified: this.props.onTxnUnverified
        })
      });
      
      if (this.state.token) { //FIND COACH OPTIONS FOR EXISTING CLUBS
        $.ajax({
          headers: {
            "token": this.state.token,
            "organization_id": this.props.club_id, //this.state.organization_id,
            "user_type": "coachadmin"
          },
          method: "GET",
          dataType: "json",
          url: `${end_point('users')}/users`,
        }).then(this.coachesGetHandler.bind(this))
      } else {
        var temp = []
        temp.push(
          <option key="select" value="" disabled selected>Select</option>,
          <option key="new-coach" value="new-coach">Add New Coach</option>
        )
        this.setState({ coachOptions : temp })
      }
    }
  }

  getTeams = (selected_league) => {
    const { all_programs, teamOptions} = this.state
    const options = [
      <option value="" key="0" selected disabled>Select</option>,
      <option value="new" key="1">Add New Team</option>,
    ]
    // var data = {
    //   token: this.state.token,
    //   export: true,
    //   organization_id: this.props.club_id ? this.props.club_id : this.state.organization_id
    // }

    // $.ajax({
    //   data: data,
    //   method: "GET",
    //   dataType: "json",
    //   url: `${end_point()}/rosters/1`
    // }).then(data => {
    //   console.log('rosters', data.message, typeof data.message)
    //   if (typeof data.message === 'object') {
    //     data.message.forEach(roster => {
    //       roster.teams.forEach(team => {
    //         if (team.name !== 'Enrolment') {
    //           all_programs.forEach(program => {
    //             // bring back valid team options
    //             console.log('all programs. each:', program)
    //             if (
    //               program._id === roster.program_id && 
    //               program.division === selected_league.division && 
    //               program.status !== 'Expired' &&
    //               program.group_name !== selected_league.group_name // doesn't show already enrolled teams in league
    //               ) {
    //               options.push(
    //                 <option value={team.name} key={makeUniqueKey()}>
    //                   {program.group_name} | {team.name}
    //                 </option>
    //               )
    //             }
    //           })
              
    //         }
    //       })
    //     })
    //   }
    //   this.setState({ teamOptions: options })
    // });
    this.setState({ teamOptions: options })
  }

  haveEnrolmentData = (enrolmentData) => {
    enrolmentData.forEach(league => {
      var teamNames = []
      if (league?.enrolled_teams?.length > 0) {
        league.enrolled_teams.forEach(team => {
          teamNames.push(team.name.toLowerCase())
        })
      }
      league.enrolled_teams = teamNames
    })
    var leagues = {
      message: enrolmentData
    }
    addStatus(leagues)
    this.setState({ all_leagues: enrolmentData })
    if (this.state.search) {
      this.filterList();
    } else if (getParams().transaction_id){
      var transaction_id = getParams().transaction_id
      this.transactionExisted(transaction_id)
    } else if(getParams().clubteamUser){
      this.setState({ clubteamUser: true })
      this.clubteamExisted(enrolmentData)
    } else {
      this.getOpenLeagues()
    }
  }

  filterList = () => {
    var temp_programs = [];
    this.state.all_leagues.forEach(program => {
      // programs need to have open registration dates
      if (!program.clone) {
        if ((new Date()).toISOString() >= program.registration_start_date) {
          if ((new Date()).toISOString() <= program.registration_end_date) {
            temp_programs.push(program)
          }
        }
      }
    })
    this.setState({
      leagues: filterSearch(temp_programs, this.state.search)
    });
  }



  loadLeagueOptions = () => {

    var options = this.state.leagueOptions // .slice()
    var selected_leagues = this.state.selected_leagues
    var currentSelection = selected_leagues.slice(-1)[0] ? selected_leagues.slice(-1)[0] : []
    if (this.state.leagues.length > 0 && !getParams().EF1) {
        this.state.enrolInLeagues && (
          this.state.leagues.forEach((league) => {
          var division = league.division.charAt(0).toUpperCase() + league.division.slice(1);
          if (league.division === "co-ed") {
            division = "Co-Ed"
          }
          
          if (selected_leagues.length > 0) {
            var findLeague = selected_leagues.find(selectedLeague => selectedLeague._id === league._id)
            if (findLeague) {
              options.forEach((option, i) => {
                if (option.key === findLeague._id || option.key === `${findLeague._id}+1`) {
                  options.splice(i, 1)
                }
              })
              
              if (window.matchMedia("(max-width: 750px)").matches && navigator.platform === "iPhone") {
                options.push(
                  <label className="white-text program-option disable-option" value={findLeague._id} key={`${league._id}+1`} disabled style={{width: '100%'}}>
                    {findLeague.ages} | {division} | {findLeague.group_name} (Selected)
                  </label>
                )
              } else {
                options.push(
                  <option className="white-text program-option disable-option" value={findLeague._id} key={`${league._id}+1`} disabled>
                    {findLeague.ages} | {division} | {findLeague.group_name} (Selected)
                  </option>
                )
              }
            } else {
              options.push(
                <option className="white-text program-option" value={league._id} key={league._id} selected={league._id === currentSelection._id}>
                  {league.ages} | {division} | {league.group_name}
                </option>
              )
            }
          } else {
            if (league.clone !== true) { // should only enrol in original leagues
              if (window.matchMedia("(max-width: 750px)").matches && navigator.platform === "iPhone") {
                options.push(
                  <label className="white-text program-option" style={{width: '100%'}} onClick={() => this.leagueSelectHandler(league._id)} value={league._id} key={league._id}>{league.ages} | {division} | {league.group_name}</label>
                )
              } else {
                options.push(
                  <option className="white-text program-option" value={league._id} key={league._id} selected={league._id === currentSelection._id}>
                    {league.ages} | {division} | {league.group_name}
                  </option>
                )
              }
            }
          }
        })
      )
    } else if (this.state.loading) {
      options.push( <option className="white-text program-option" value={'select'} key={makeUniqueKey()} disabled selected>Loading...</option> )
    } else if (getParams().EF1) {
      if (window.matchMedia("(max-width: 750px)").matches && navigator.platform === "iPhone") {
        options.push(
          <label className="white-text program-option" value='apply' style={{width: '100%'}} onClick={() => this.leagueSelectHandler('apply')}>
            Click Here to Register
          </label>
        )
      } else {
        options.push(<option key="applyNow" className="white-text program-option" value='apply'>
          Click Here to Register
        </option>)
      }
    } else {
      options.push( <option className="white-text program-option" value={'select'} key={makeUniqueKey()} disabled selected>Enrolment is closed</option> )
    }
    // console.log('leagueOptions?', options)
    this.setState({
      leagueOptions: options,
      showPricingBreakdown:false,
    })
  }



  handleDate = (val, setFieldValue) => {
    this.setState({ DOB: val })
    if (val) {
      setFieldValue('AH_DOB', val.utc().format())
    } else {
      setFieldValue('AH_DOB', null)
    }
  }

  transactionExisted = (transaction_id) => {
    const { token, organization_id } = this.state
    const rthis = this
    $.ajax({
      headers: {
        "token": token,
        "organization_id": organization_id,
        "transaction_id": transaction_id
      },
      method: "GET",
      contentType: 'application/json',
      url: this.state.transactionEndpoint,
      success: function (data) {
        if (data.errorMessage) {
          alert(data.errorMessage);
        } else {
          var transaction_info = data.message
          if (rthis.state.parent.first_name === transaction_info[0].parent.first_name && rthis.state.parent.last_name === transaction_info[0].parent.last_name) {
            transaction_info.length !== 1 ? alert('We are unable find your transaction, please email support@hoopstir.com.')
            : rthis.transactionFound(transaction_info)
          } else {
            alert('This invitation was not sent to you. Please sign in with the email that received the invitation to complete your enrolment.')
            window.location.href = document.location.origin + "/logout?jwt=" + rthis.state.token
          }
        }
      },
      error: function (data){
        alert('We are unable to connect our server, please email support@hoopstir.com \n Error Message', data )
      }
    })
  }

  transactionFound = (data) => {
    const transaction = data[0]
    // if the parent has paid already, then just display normal enrolment form
    if ((transaction.payment_gateway.type.type === 'gratis' && transaction.payment_gateway.status[transaction.payment_gateway.status.length-1].status === 'unpaid') || transaction.payment_gateway.status[transaction.payment_gateway.status.length-1].status === 'paid') {
      alert('This invitation has already been accepted.')
      window.location.href = document.location.origin + "/portals?jwt=" + this.state.token + "&protalMode=parent"
    } else {
      const { all_leagues } = this.state
      var program = all_leagues.filter(program => program._id === transaction.program._id)
      let instalments = []
      var selected_program = program[0]
      //look if instalment options exist
      selected_program.plans.forEach(plan => {
        if(plan._id === transaction.plan._id ){
          instalments = plan.instalments? plan.instalments: []
          selected_program.plans = [plan]
        }
      })
      this.setState({
        programs: program,
        selected_program: program[0],
        selected_plan: transaction.plan._id,
        waitlistTransaction: transaction,
        transaction_id: transaction._id,
        instalments: instalments,
        instalment_number: transaction.price_breakdown.instalment_number? transaction.price_breakdown.instalment_number: 1
      })
    }
  }

  getOpenLeagues = () => {
    var temp_leagues = [];
    var year = (new Date()).getFullYear()
    var date = ("0" + (new Date()).getDate()).slice(-2)
    var month = ("0" + ((new Date()).getMonth() + 1)).slice(-2)
    var today = `${year}-${month}-${date}T00:00:00.000Z`
    this.state.all_leagues.forEach(program =>{
      if(today>= program.registration_start_date){
        if(today <= program.registration_end_date){
          temp_leagues.push(program)
        }
      }
    })
    console.log('getOpenLeagues', temp_leagues)
    this.setState({ leagues: temp_leagues })
  }

  handleWaiverModal = () => {
    this.setState({ showWaiverModal: !this.state.showWaiverModal })
  }


  resetPricingBreakdown = () => {
    if (this.state.showPricingBreakdown) {
      this.setState({ 
        showPricingBreakdown: false, 
        displayPaymentForm: false, 
        checkBoxDisabled: false 
      }, () => document.getElementById("promotion_code").focus() )
    
    }
  }

  addCheckedSelection = (val) => {
    const { leagues, selected_leagues, EF1 } = this.state
    var selected_league = leagues.find((element) => { return element._id === val })
    var options = this.state.leagueOptions
    console.log('selected_league', selected_league)
    console.log('add Checked Selection -leagues', options)
    if (val === 'apply') {
      options = <label className="white-text program-option checked" style={{width: '100%'}} onClick={() => this.leagueSelectHandler('apply')} value='apply'>Click Here to Register</label>
    } else {
      options.forEach((option, i) => {
        if (option.key === selected_league._id) {
          console.log('checked', selected_league, '\noption.key', option.key)
          var division = selected_league.division.charAt(0).toUpperCase() + selected_league.division.slice(1);
          if (selected_league.division === "co-ed") {
            division = "Co-Ed"
          }
  
          var selectedOption
          if (navigator.platform !== "iPhone") {
            selectedOption = <option className="white-text program-option checked" value={selected_league._id} key={selected_league._id}>
            {selected_league.ages} | {division} | {selected_league.group_name}
          </option>
          } else {
            selectedOption = <label className="white-text program-option checked" style={{width: '100%'}} onClick={() => this.leagueSelectHandler(selected_league._id)} value={selected_league._id} key={selected_league._id}>{selected_league.ages} | {division} | {selected_league.group_name}</label>
          }
          options.splice(i, 1, selectedOption)
        } else {
            if (option.key !== selected_league._id && option.props.className === "white-text program-option checked") {
              var league = leagues.find((element) => { return element._id === option.key })
              console.log('option:', option.key, option.props.className)
              var division = league.division.charAt(0).toUpperCase() + league.division.slice(1);
              if (league.division === "co-ed") {
                division = "Co-Ed"
              } else {
                division = ""
              }
  
              var otherOption
              if (navigator.platform !== "iPhone") {
                otherOption = <option className="white-text program-option" value={league._id} key={league._id}>
                {league.ages} | {division} | {league.group_name}
              </option>
              } else {
                otherOption = <label className="white-text program-option" style={{width: '100%'}} onClick={() => this.leagueSelectHandler(league._id)} value={league._id} key={league._id}>{league.ages} | {division} | {league.group_name}</label>
              }
              options.splice(i, 1, otherOption)
            }
          //})
        }
      })
    }
    
    this.setState({leagueOptions: options})
  }

  leagueSelectHandler = (selection, formikProps) => {
    var val = selection.target ? selection.target.value : selection
      if (window.matchMedia("(max-width: 750px)") && navigator.platform === "iPhone") {
        this.addCheckedSelection(val)
      }

    if (val) {
      if (this.state.enrolInLeagues) {
        var selectedLeagues = this.state.selected_leagues
        var selected_league = this.state.leagues.find((element) => { return element._id === val })
        
        if (this.state.showPricingBreakdown === true && this.state.multipleLeagues !== true && selectedLeagues.length >= 1) {
          var selectedLeague = selectedLeagues.slice(-1)[0]
          selectedLeagues.pop()
          var teams = this.state.teams
          teams[selectedLeague._id].pop()
          var selectedPlan = this.state.selected_plan
          delete selectedPlan[selectedLeague._id]
          var PB = this.state.pricingBreakdown
          delete PB[selectedLeague._id]
          this.setState({
            selected_leagues: selectedLeagues,
            teams,
            selected_plan: selectedPlan,
            showPricingBreakdown: false,
            instalments: [],
            enrolTeamVisible: false,
            pricingBreakdown: PB
          })
        } 
        if (selectedLeagues.length === 0) {
          selectedLeagues.push(selected_league)
        } else {
          var existingLeague = selectedLeagues.find(league => { 
            return league._id === selected_league._id
          })
          if (existingLeague) {
            var chosenLeague = selectedLeagues.indexOf(selected_league)
            selectedLeagues.splice(chosenLeague, 1)
            selectedLeagues.push(selected_league) // moving selected league back to the end
          } else {
            selectedLeagues.push(selected_league)
          }
        }
        
        var teams = this.state.teams
        if (teams[selected_league._id]) {
        } else {
          teams[selected_league._id] = [] // create a teams array for selected league
        }

        if (formikProps) {
          this.setState({formikProps})
        }
        var planChange = this.state.selected_plan
        planChange[val] = null
        console.log('planChange?', planChange)
        this.setState({
          checkFormik: false,
          teams,
          selected_leagues: selectedLeagues,
          selected_plan: planChange,
          showPricingBreakdown: false,
          instalments: [],
          showDetails: true,
          enrolTeamVisible: false
        })
        if (this.state.token) {
          if (formikProps) {
            formikProps.setFieldValue('enrolInLeagues', true)
          }
          this.getTeams(selected_league)
        } else {
          const options = [
            <option value="" key="0" selected disabled>Select</option>,
            <option value="new" key="1">Add New Team</option>,
          ]
          this.setState({ teamOptions: options })
          if (formikProps) {
          formikProps.setFieldValue('enrolInLeagues', false)
          formikProps.setFieldValue('AH_DOB', null)
          }
        }
      } else {
        //this.state.services.find((element) => { return element._id === val })
        if (formikProps) {
          formikProps.setFieldValue('enrolInLeagues', false)
          formikProps.setFieldValue('EF1', true)
        }
        this.setState({ EF1: true, showPricingBreakdown: false })
      }
    }
  }

  planSelectHandler = (selection, setFieldValue) => {
    const { selected_leagues, multipleLeagues, priceTotal, teams } = this.state
    console.log('planSelectHandler', selection)
    setFieldValue('selected_plan', selection)
    if (this.state.EF1) {

    } else {

      var plan = this.state.selected_plan
      
      var prevLeagues = selected_leagues.length > 1 ? selected_leagues.slice(0, (selected_leagues.length - 1)) : null
      
      var selectedLeague = selected_leagues.slice(-1)[0] ? selected_leagues.slice(-1)[0] : []
      
      var instalments = []
      // delete unselected leagues
      if (selected_leagues.length > 1) {
        prevLeagues.forEach(prev => {
          if (plan[prev._id] === undefined && teams[prev._id].length === 0) {
            var prevChoice = selected_leagues.indexOf(prev)
            selected_leagues.splice(prevChoice, 1)
          }
        })
      }
      console.log('what is league now?', selected_leagues)


      var selectedPlan = selectedLeague.plans.find(plan => {
        if (plan._id === selection) {
          return plan
        }
      })
      
      selectedLeague.plans.forEach(plan => {
        if (plan._id === selection && plan.instalments && plan.instalments.length !== 0) {
          if (selected_leagues.length > 1) {
            console.log('selected_leagues.length', selected_leagues, selected_leagues.length)
            window.alert('Instalment options do not work with multi-league enrolments. Please choose a different price plan before continuing.')
          } else {
            instalments = plan.instalments
          }
        }
      })

      plan[selectedLeague._id] = selectedPlan
      console.log('what is plan now ?', plan)

      var i = selected_leagues.indexOf(selectedLeague)
      selected_leagues[i] = selectedLeague

      if (multipleLeagues === true) {
        var total = priceTotal
        console.log('plan_price x teams[selectedLeague._id].length = ', selectedPlan.plan_price, '*', teams[selectedLeague._id].length )
        var teamAmt = selectedPlan.plan_price * teams[selectedLeague._id].length
        console.log('teamAmt', teamAmt)
        total -= teamAmt
        console.log('what is priceTotalNow',total)
        this.setState({ priceTotal: total})
      } else {
        this.setState({ priceTotal: 0})
      }
      
      this.setState({
        selected_leagues,
        selected_plan: plan,
        instalments,
        showPricingBreakdown: false,
        displayPaymentForm: false,
        // instalment_number: 1
      });
    }
  }

  clearPaymentFields(){
    document.getElementById('card').value = "";
    document.getElementById('exp_year').value = "";
    document.getElementById('exp_month').value = "";
    document.getElementById('cvv').value = "";
    document.getElementById('card').focus();
  }

  requestToken(transaction_id){
    console.log('in request token - org id?', this.state.organization_id)
    var rthis = this;
    $.ajax({
      url: this.state.loginEndpoint,
      type: 'GET',
      dataType: 'json',
      headers: {
        "function": 'check_password_correct',
        "email": this.props.email,
        "password": this.props.password,
        "organization_id": this.state.organization_id
      },
      success: function (data) {
        if (data.errorMessage) {
          alert('Unable to identify the user, please email support@hoopstir.com.')
        } else {
          console.log('token success', data.message)
          if (rthis.state.waitlistInitialSignup) {
            rthis.setState({
              transaction_id: transaction_id,
              displayPaymentForm: true,
              newToken: data.message,
              confirm_spinner: false,
              paymentStatus: 'waitlist'})
          } else if (rthis.state.pricingBreakdown.total === 0) {
            rthis.setState({ newToken: data.message })
            var response = total0Recept()
            rthis.patchReceipt(transaction_id, response, 'finalizeEF2')
          } else {
            rthis.setState({
              transaction_id: transaction_id,
              displayPaymentForm: true,
              confirm_spinner: false,
              newToken: data.message
            })
          }
        }
      },
      error: function (data){
        alert('Server error while getting user token, please email support@hoopstir.com.')
      }
    });
  }

  // ---------------- ENROL TEAMS ----------------
  
  coachesGetHandler = (coaches) => {
    var temp = [];
    var option = null;
    temp.push(
    <option key="select" value="" disabled selected>Select</option>,
    <option key="new-coach" value="new-coach">Add New Coach</option>
    )
    coaches.message.forEach((coach) => {
      option = <option key={coach._id} value={coach._id}>{coach.first_name + " " + coach.last_name}</option>
      temp.push(option)
    })
    this.setState({ coachOptions: temp, coaches: coaches.message })
  }

  // to display the dropdown menu for coaches
  addCoach = (index) => {
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    var tempTeams = this.state.teams[selectedLeague._id].slice()
    var teams = this.state.teams
    var tempTeam = tempTeams[index]
    tempTeam.addCoach = true
    tempTeams[index] = tempTeam
    teams[selectedLeague._id] = tempTeams
    this.setState({ teams })
  }

  selectCoach = (e, index, setFieldValue) => {
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    var tempTeams = this.state.teams[selectedLeague._id].slice()
    var teams = this.state.teams
    var tempTeam = tempTeams[index]

    if (e.target.value === 'new-coach') {
      // when existing coach was selected and new coach is now selected
      tempTeam.coach._id = ''
      tempTeam.coach.first_name = ''
      tempTeam.coach.last_name = ''
      tempTeam.coach.phone = ''
      tempTeam.coach.email = ''
      console.log('changing coach/adding new coach', tempTeam.coach)
      // --------------------------------------------------------------
      tempTeam.addCoachDetails = true
      tempTeam.existingCoach = false
      tempTeam.disableTeamSubmit = true

      tempTeams[index] = tempTeam
      teams[selectedLeague._id] = tempTeams

      this.setState({ teams })
    } else {
      this.state.coaches.forEach(coach => {
        if (coach._id === e.target.value) {
          return this.addTeam(coach, 'existing', index, setFieldValue)
        }
      })
    }
  }

  addTeam = (coach, type, index, setFieldValue) => {
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    var tempTeams = this.state.teams[selectedLeague._id].slice()
    var teams = this.state.teams
    var tempTeam = tempTeams[index]
    switch (type) {
      case 'existing':
        tempTeam = {
          newTeam: tempTeam.newTeam,
          name: tempTeam.name,
          coach: {
            _id: coach._id,
            first_name: coach.first_name,
            last_name: coach.last_name,
            phone: coach.extras.phone,
            email: coach.email,
          },
          addTeam: true,
          existingCoach: true,
          addCoach: true,
          disableTeamSubmit: true
        }
        break
      case 'new':
        tempTeam = {
          newTeam: tempTeam.newTeam,
          name: tempTeam.name,
          coach: coach.coach,
          addTeam: true,
          existingCoach: false,
          addCoach: true,
          disableTeamSubmit: true
        }
        break
      case 'noCoach':
        tempTeam = {
          newTeam: tempTeam.newTeam,
          name: tempTeam.name,
          addTeam: true,
          addCoach: false,
          existingCoach: false,
          disableTeamSubmit: true
        }
        break
      default:
        alert('invalid form field')
    }

    tempTeams[index] = tempTeam
    teams[selectedLeague._id] = tempTeams
    setFieldValue('teams', JSON.stringify(teams))
    this.setState({ teams, enrolTeamVisible: false, showPricingBreakdown:false })
  }

  handleChange = (val, index, field) => {
    const { selected_plan } = this.state
    var value = val.target.value
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    var teams = this.state.teams
    var tempTeams = teams[selectedLeague._id].slice()
    var tempTeam = tempTeams[index]
    var tempPlan = Object.assign({}, selected_plan)

    switch (field) {
      case 'name':
        if (value === 'new') {
          tempTeam.name = ''
          tempTeam.newTeam = true
        } else {
          //separate into different fn later
          if (selectedLeague.enrolled_teams.length > 0) {
            var match = selectedLeague.enrolled_teams.includes(value.toLowerCase())

            if (match === true) {
              tempTeam.existingName = true
              tempTeam.disableTeamSubmit = true
            } else {
              tempTeam.existingName = false
              if (tempTeam.existingCoach) {
                tempTeam.disableTeamSubmit = false
              }
            }
            tempTeam.name = value
          } else {
            tempTeam.existingName = false
            tempTeam.name = value
            if (tempTeam.existingCoach) {
              tempTeam.disableTeamSubmit = false
            }
          }
        }
        break
      case 'first_name':
        tempTeam.coach.first_name = value
        break
      case 'last_name':
        tempTeam.coach.last_name = value
        break
      case 'phone':
        tempTeam.coach.phone = value
        break
      case 'email':
        tempTeam.coach.email = value
        var validate = validateEmail(value)
        if (validate) {
          tempTeam.invalidEmail = false
          if (!tempTeam.existingName && tempTeam.name !== "") {
            tempTeam.disableTeamSubmit = false
          }
        } else {
          tempTeam.invalidEmail = true
          tempTeam.disableTeamSubmit = true
        }
        break
      default:
        alert('invalid form field')
    }
    var options= []
    for (var i = 0, l = tempTeams.length; i < l; i++) {
      options.push(tempTeams[i])
    }
    tempTeams[index] = tempTeam
    teams[selectedLeague._id] = tempTeams
    this.setState({ teams, showPricingBreakdown: false })
  }

  enrolTeamVisible = () => {
    this.setState({enrolTeamVisible: true})
    var leaguesSelected = this.state.selected_leagues
    const { teams, selected_plan } = this.state
    var selectedPlan = selected_plan
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
      teams[selectedLeague._id].push({
      newTeam: false,
      existingCoach: true,
      name: "",
      coach: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      },
      addCoach: false,
      addCoachDetails: false,
      addTeam: false,
      disableTeamSubmit: true,
    })

    // any selections (clicks on program selector) get added to selected_leagues array. need to delete when they begin to fill out the form. Would create issues when enrolling in another league (as options in this array will be disabled)
    for (var league in teams) {
      if (teams[league].length === 0) {
        leaguesSelected.forEach(selectedLeague => {
          if (selectedLeague._id === league) {
            var index = leaguesSelected.indexOf(selectedLeague)
            leaguesSelected.splice(index, 1)
            delete selectedPlan[selectedLeague._id]
          }
        })
        delete teams[league]
      }
      
    }

    if (!this.state.multipleLeagues) {
      console.log('!this.state.multipleLeagues')
      this.planSelectHandler((selected_plan[selectedLeague._id] ? selected_plan[selectedLeague._id]._id : selectedLeague.plans[0]._id), this.state.formikProps.setFieldValue)
    }

    this.setState({
      selected_leagues: leaguesSelected,
      enrolTeamVisible: true, 
      teams, 
      showPricingBreakdown: false,
      selected_plan : selectedPlan
    })
  }

  cancelTeam = (i) => {
    console.log('cancel team', i)
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    var teams = this.state.teams
    var tempTeams = teams[selectedLeague._id].slice()
    tempTeams.splice(i, 1)
    teams[selectedLeague._id] = tempTeams
    this.setState({ enrolTeamVisible: false, teams, showPricingBreakdown: false })
  }

  removeTeam = (clicked) => {
    var i = clicked.target.value
    console.log('cancel team', i)
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    var teams = this.state.teams
    var tempTeams = teams[selectedLeague._id].slice()

    tempTeams.splice(i, 1)
    teams[selectedLeague._id] = tempTeams
    this.setState({ teams, showPricingBreakdown: false })
  }

  checkSavedTeams = (e) => {
    const {selected_plan } = this.state
    // this.setState({multipleLeagues: true})
    
    var teams = this.state.teams
    var selected_league = this.state.selected_leagues.slice(-1)[0]
    console.log('selected_plan', selected_plan[selected_league._id])
    console.log('selected_league', selected_league)
    var lastTeam = teams[selected_league._id].slice(-1)[0]
    if (lastTeam && lastTeam.addTeam === false || lastTeam && lastTeam.disableTeamSubmit === true && lastTeam.addTeam === false) {
      e.preventDefault()
      e.stopPropagation()
      window.alert('Please save your team to continue.')
    } else if (selected_plan[selected_league._id] && selected_plan[selected_league._id].instalments.length > 0 && this.state.selected_leagues.length !== 1) {
      e.preventDefault()
      e.stopPropagation()
      window.alert('Instalment options do not work with multi-league enrolments. Please choose a different price plan before continuing.')
      this.setState({ instalments: [], instalment_number: 1})
    } else {
      this.setState({
        checkFormik: true
      })
    }
  }

  checkEmptyFields = () => {
    window.alert("A required field is missing. Please review your entries and make corrections where noted.")
    this.setState({checkFormik: false, showPricingBreakdown: false})
  }

  renderTeams = (setFieldValue) => {
    var addControl = null;
    var selectedLeague = this.state.selected_leagues.slice(-1)[0]
    if (this.state.enrolTeamVisible) {
      this.state.teams[selectedLeague._id].map((input, index) => {
        addControl =
        <Row>

          { input.newTeam ?
            <Col lg={3} xs={6} >
              <ControlLabel>Team Name</ControlLabel>
              <FormControl 
              value={input.name} 
              placeholder="" 
              id="teams.name"
              name ="teams.name"
              onChange={(val) => this.handleChange(val, index, 'name')} className="opaque-grey" type="text"/>
              { 
                input.name === "" ? 
                <div className="invalid-feedback">Required Field</div>
                :
                input.existingName ?
                <div className="invalid-feedback">Team name already exists. Choose another</div>
                :
                ""
              }
            </Col>
            :
            <Col lg={3} xs={6}>
              <ControlLabel>Team Name</ControlLabel> 
              <FormControl className="opaque-grey" name="teams.name" componentClass="select" id="teams.name" onChange= {(val) => this.handleChange(val, index, 'name')}>
                {this.state.teamOptions}
              </FormControl>
              { 
                input.name === "" ? 
                <div className="invalid-feedback">Required Field</div>
                :
                ""
              }
            </Col>
          }
            <Col sm={3} xs={6} className="add-team-option" style={{padding: '0', marginLeft: '15px'}}>
              <ControlLabel className="no-title">Save</ControlLabel>
              <div className="save-team">
                <Button className="planfeaturebtn" onClick={() => this.addTeam(input, "noCoach", index, setFieldValue)} disabled={input.disableTeamSubmit}>Save Team</Button>
                <Button className="deleterow" style={{ marginLeft: "8px" }} onClick={() => this.cancelTeam(index)}>cancel</Button>
              </div>
            </Col>
        </Row>
      })
    } else {
      addControl =

        <Button 
        className="add-session-btn" 
        style={{ marginTop: "10px" }}
        onClick={() => this.enrolTeamVisible()} 
        disabled={this.state.disabled}>
          Add Team
          </Button>
  
    }
    return (
      <Fragment>
        {
          selectedLeague && this.state.teams[selectedLeague._id].map((input, index) => {
          return (
            <Row style={{marginTop: ".25rem" }}>
              { input.addTeam &&
              <>
                { input.newTeam ?
                <Col lg={3} xs={6}>
                  <ControlLabel>Team Name</ControlLabel> 
                  <FormControl value={input.name} id="teams.name" name ="teams.name" disabled className="col-sm-2 opaque-grey" type="text"/>
                </Col>
                :
                <Col lg={3} xs={6}>
                  <ControlLabel>Team Name</ControlLabel> 
                  <FormControl value={input.name} className="opaque-grey" name ="teams.name" componentClass="select">
                  {this.state.teamOptions}
                  </FormControl>
                </Col>
                
                }
                <Col lg={2} xs={6}>
                  <Button 
                    style={{marginTop: "23px" }}
                    className="deleterow" 
                    value={index} onClick={(e) => this.removeTeam(e)} 
                    disabled={this.state.disabled}
                  >
                    Delete Team
                  </Button>
                </Col>
              </>
            }
            </Row>
          )
        })}
        {addControl}
      </Fragment>
    )
  }

  checkPaymentInfo(){
    if (document.getElementById('card').value.length !== 16){
      alert("Please make card number 16 digits.")
      return false
    }
    if (document.getElementById('exp_year').value.length !== 2){
      alert("Please make Expiration Year 2 digits")
      return false
    }
    if (document.getElementById('exp_month').value.length !== 2){
      alert("Please make Expiration Month 2 digits")
      return false
    }
    if (!(document.getElementById('cvv').value.length === 3 || document.getElementById('cvv').value.length === 4)){
      alert("Please make CVV 3 or 4 digits.")
      return false
    }
    return true
  }

  pay = () => {
      const { FormikValues, transaction_id, pricingBreakdown, current_user, token, pricingEndpoint, dataReserve, convergeToken, selected_leagues } = this.state

      var checkPaymentInfo = this.checkPaymentInfo()
      var selectedLeague = selected_leagues.slice(-1)[0] ? selected_leagues.slice(-1)[0] : null
      var rthis = this;
      
      if (checkPaymentInfo) {
        console.log("checking PaymentInfo", checkPaymentInfo)
        this.setState({ pay_spinner: true})
        var email = this.state.admin_email
        var card = document.getElementById('card').value
        var exp_year = document.getElementById('exp_year').value
        var exp_month = document.getElementById('exp_month').value
        var cvv = document.getElementById('cvv').value
        var firstName = token ? current_user.first_name : FormikValues.AH_first_name
        var lastName = token ? current_user.last_name : FormikValues.AH_last_name
        // league payments should be in full and not paid in installments (for now)
        var paymentData = {
          ssl_txn_auth_token: convergeToken,
          ssl_card_number: card,
          ssl_exp_date: `${exp_month}${exp_year}`,
          ssl_cvv2cvc2: cvv,
          ssl_amount: pricingBreakdown.total,
          ssl_email: email,
          ssl_first_name: firstName,
          ssl_last_name: lastName,
          ssl_invoice_number: transaction_id, 
          leagues: true
        }

        if (pricingBreakdown[selectedLeague._id].instalment_number === 1) {
          paymentData.ssl_amount = pricingBreakdown.total
        } else if (pricingBreakdown[selectedLeague._id].instalment_number > 1) {
          let formattedDate = mmddyyyyDateFormat(new Date())
          paymentData.ssl_amount = pricingBreakdown[selectedLeague._id].instalment_total
          paymentData.ssl_transaction_type = 'ccaddinstall'
          paymentData.ssl_total_installments = this.state.instalment_number
          paymentData.ssl_billing_cycle = 'MONTHLY'
          paymentData.ssl_next_payment_date = `${formattedDate}`
          if(formattedDate.slice(3,5) == '28' || 
            formattedDate.slice(3,5) == '29' || 
            formattedDate.slice(3,5) == '30' || 
            formattedDate.slice(3,5) == '31') {
            paymentData.ssl_end_of_month = 'Y'
          }
        } else {
          window.confirm('Something went wrong. Please contact support')
          console.log('pricingBreakdown[selectedLeague._id].instalment_number ?', pricingBreakdown[selectedLeague._id].instalment_number )
        }

        
        console.log('paymentData In Full', paymentData)

        var callback = {
          onError: function (error) {
            console.log('error', error)
            alert("Your payment was incomplete, Please try again")
            rthis.setState({ paymentStatus: 'error', pay_spinner: false })

            rthis.generateConvergeToken((token, err) => {
              if(err){
               alert(err.message)
               rthis.setState({ continue_spinner: false });
              } else {
                $.ajax({
                  dataType: "json",
                  url: pricingEndpoint,
                  data: dataReserve,
                  success: (results) => {
                    console.log("RESULTS=", results)
                  },
                  error: (err) => {
                    alert('Unable to process transaction, please try again.')
                  }
                })
              }
            })
          },
          onDeclined: function (response) {
            console.log('onDeclined. response:', response)
            alert("Your payment was declined, Please try again")
            rthis.setState({ paymentStatus: 'declined', pay_spinner: false })
            // rthis.clearPaymentFields()

            rthis.generateConvergeToken((token, err) => {
              //console.log('generateConvergeToken again')
              if(err){
               alert(err.message)
               rthis.setState({ continue_spinner: false });
              } else {
                $.ajax({
                  dataType: "json",
                  url: pricingEndpoint,
                  data: dataReserve,
                  success: (results) => {
                    console.log("RESULTS=", results)
                  },
                  error: (err) => {
                    alert('Unable to process transaction, please try again.')
                  }
                })
              }
            })
          },
          onApproval: function (response) {
            console.log('approved. response:', response)
            response.leagues = true
            rthis.patchReceipt(transaction_id, response, 'finalizeEF2');  
          }
        };
        console.log("going to ConvergeEmbeddedPayment")
        window.ConvergeEmbeddedPayment.pay(paymentData, callback);
        return false;
      }
  }

  patchReceipt(transaction_id, receipt, finalize){
    console.log("patching receipt", transaction_id, "receipt", receipt)
    const {pricingBreakdown, newToken, token, selected_leagues, organization_id, organization } = this.state
    var rthis = this
    var data = {
      receipt: receipt,
      transaction_id: transaction_id, 
      organization: organization
    }
    data.receipt.transaction_id = transaction_id
    data.receipt.leagues = true

    if (finalize) {
      console.log('finalizing EF2 transaction', this.state.current_user)
      data.programs = []
      // send data for cloning program 
      selected_leagues.forEach(league => {
        console.log("league", league)
        var program = league.clonedProgram
        program.league_organization_id = this.state.league._id // need for EF3 converge acc
        program.league_program_id = league._id // need this for rosters
        program.head_coach = token ? this.state.current_user._id : league.commissioner_1
        program.organization_id = token ? this.props.club_id : organization_id
        program.enrolled_teams = this.createTeamData(league._id)
        program.clone = true
        console.log("program to clone", program)
        data.programs.push(program)
      })
      data.leagueEmail = this.state.league.enrolment_emails
      console.log('finalize data:', data)
    } 

    if(this.state.waitlistTransaction) {
      data.waitlist_update = true
      data.price_breakdown =  pricingBreakdown
    } else if (this.state.clubteamUser){
      data.clubteam_user = true
    }

    console.log('newToken', newToken, '\nor Token:', token)
    if (!token) {
      data.newOrg = true
    }
    console.log('patchReceipt data', JSON.stringify(data))
    $.ajax({
      headers: {
        "token": newToken ? newToken : token,
      },
      method: "PATCH",
      contentType: 'application/json',
      data: JSON.stringify(data),
      url: this.state.transactionEndpoint,
      success: function (data) {
        if (data.errorMessage) {
          alert(data.errorMessage);
        }
        else {
          console.log('after PATCH transactionendpoint', data)
          if(rthis.state.pricingBreakdown.total === 0){
            // console.log('pricingBreakdown total=', rthis.state.pricingBreakdown.total )
            rthis.setState({
              displayPaymentForm: true,
              confirm_spinner: false,
              paymentStatus: 'approved'
            })

          } else {
            rthis.setState({ paymentStatus: 'approved', pay_spinner: false });
          }
        }
      },
      error: function (data){
        alert('Your payment went through but we are unable to update your status, please email support@hoopstir.com' + '\nerror: ' + data.status)
      }
    })
  }

  handleApprovedSignOut = () => {
    this.state.token ?
    window.location.href = document.location.origin + "/logout?jwt=" + this.state.token
    :
    window.location.href = document.location.origin + "/logout"
  }

  handleApprovedRedirect = () => {
    window.location.href = document.location.origin + "/portals?jwt=" + this.state.token + "&protalMode=parent";
  }

  handleSignIn = () => {
    window.location.href = document.location.origin + "/login?organization_id=" + (this.state.token ? this.props.club_id : this.state.organization_id)
  }
  
  enrolInMoreLeagues = (resetPB) => {
    const {selected_leagues, pricingBreakdown, formikProps } = this.state
    var selectedLeague = selected_leagues.slice(-1)[0] ? selected_leagues.slice(-1)[0] : null
    if (pricingBreakdown[selectedLeague._id].instalment_number > 1) {
      window.alert('Instalment options do not work with multi-league enrolments. Please pay for you current enrolment before continuing.')
    } else {
      if (window.confirm(`Are you sure you want to enrol in more leagues?`)) {
        if (navigator.platform === "iPhone") {
          this.setState({
            showPricingBreakdown:false,
            showDetails: false,
            multipleLeagues: true
          })
          this.loadLeagueOptions()
        }
        if (!this.state.token) {
          formikProps.setFieldValue('enrolInLeagues', true)
          formikProps.setFieldValue('teams', '')
          formikProps.setFieldValue('selected_plan', '')
          formikProps.setFieldValue('agree_waver', false)
        } else {
          formikProps.handleReset()
        }
        
        if (resetPB) {
          console.log('enrolInMoreLeagues:resetPB?', resetPB)
          this.setState({
            disabled: false,
            pricingBreakdown: {},
            newOrg: true,
            paymentStatus: null,
            showPricingBreakdown:false,
            selected_leagues: [],
            leagueOptions: [],
            showDetails: false,
            instalments: [],
            multipleLeagues: false,
            teams: {}
          }, () => this.loadLeagueOptions())
        } else {
          this.setState({
            instalments: [],
            leagueOptions: [],
            showPricingBreakdown:false,
            showDetails: false,
            multipleLeagues: true,
          }, () => this.loadLeagueOptions())
        }
        
      }
    }
  }

  createTeamData(id) {
    var teams = []
    this.state.teams[id].forEach(team => {
      team.id = ''
      team.coach = ''
      team.items = []
      // Delete unnecessary fields
      delete team.newTeam
      delete team.addCoach
      delete team.addTeam
      delete team.existingCoach
      delete team.disableTeamSubmit
      // console.log('createTeamData with Coach details?', team)
      teams.push(team)
    })
    return teams
  }

  createData = async (values) => {
    const { selected_leagues, token, organization_id, selected_plan, teams, EF1 } = this.state
    var data = {
      organization: {},
      price_breakdown: this.state.pricingBreakdown,
    }

    if (EF1) {
      this.setState({ 
        continue_spinner: true,
        disabled: true
      })
      data.EF1 = true
      // ----- CREATE USER -----
      data.user = {
        first_name: values.AH_first_name,
        last_name: values.AH_last_name,
        email: this.state.admin_email,
        organization_ids: [],
        marketing_opt_out: false,
        extras: {
          phone: values.AH_phone,
          date_of_birth: this.state.DOB,
          address: `${values.AH_address} ${values.AH_city} ${values.AH_province} ${values.AH_country} ${values.AH_postal}`
        },
        create_date: new Date(),
        archived: {
          status: true, // to save their info but they cannot login until Graham has approved their application 
        },
        type: "admin",
        password: localStorage.getItem('password')
      }

      // ----- CREATE ORGANIZATION -----
      data.organization = {
        name: values.org_name,
        description: "Please add org description",
        email: values.org_email,
        phone: values.org_phone,
        address: `${values.org_address} ${values.org_city} ${values.org_province} ${values.org_country} ${values.org_postal}`,
        logo: "",
        payment_credentials: {
          ssl_merchant_id: "",
          ssl_user_id: "",
          ssl_pin: "",
          ssl_transaction_type: "ccsale",
          ssl_amount: "10.00",
        },
        business_details: {
          business_name: values.business_name,
          business_no: values.business_no,
          business_type: values.business_type,
          yr_est: values.yr_est,
          annual_rev: +values.annual_rev,
          mthly_sale: +values.mthly_sale,
          avg_tnx: +values.avg_tnx,
          max_tnx: +values.max_tnx,
        },
        merch:  [
          {
            "name" : "Add Merch",
            "logo" : "tshirt.svg",
            "size" : [ "-", "YS", "YM", "YL", "AS", "AM", "AL", "AXL" ]
          },
          {
            "name" : "Add Merch",
            "logo" : "tshirt.svg",
            "size" : [ "YS", "YM", "YL", "AS", "AM", "AL", "AXL" ]
          },
          {
            "name" : "Add Merch",
            "logo" : "tshirt.svg",
            "size" : [ "YS", "YM", "YL", "AS", "AM", "AL", "AXL" ]
          }
        ],
        enrolment_emails: this.state.admin_email,
        waiver: "Please add a waiver",
        archived: {
          status: false
        },
        travel_waiver: "Please add a travel waiver",
        social: {
          website: values.org_website,
        }
      }
      console.log('EF1 data:', data)

      // ----- ADD ATTACHMENTS -----
      var attachments = []
      var convertedFiles = []
      for (var file of this.state.attachments) {
        var converted = await this.toBase64(file)
        console.log('converted file')
        convertedFiles.push(converted)
      }

      if (convertedFiles.length > 0) {
        convertedFiles.forEach((result, i) => {
          attachments.push({
            "type": this.state.attachments[i].type,
            "fileName": this.state.attachments[i].name,
            "file": result.split(',')[1]
          })
        })
        data.attachments = attachments
        console.log('attachments???', attachments)
      }

    } else {
      data.programs = []
      data.plans =  selected_plan
      data.leagueID = organization_id
      
      selected_leagues.forEach(league => {
        let teamNames = []
        teams[league._id].forEach(team => {
          teamNames.push(team.name)
        })
        var program = {
          _id: league._id,
          name: league.group_name,
          type: league.type,
          teams: teamNames
        }
        data.programs.push(program)
      })
      console.log('what about teams for this league', data.programs)
      if (token || this.state.newOrg === true) {
        console.log('org exists', organization_id, "current user?", this.state.current_user)
        data.organization = {
          organization_id: token ? this.props.club_id : organization_id,
        }
        data.user = this.state.current_user
      } else {
        console.log('new user')
        var orgAddress = `${values.org_address} ${values.org_city} ${values.org_province} ${values.org_country} ${values.org_postal}`
        
        data.user = {
          first_name: values.AH_first_name,
          last_name: values.AH_last_name,
          email: this.state.admin_email,
          organization_ids: [],
          marketing_opt_out: false,
          extras: {
            phone: values.AH_phone,
            date_of_birth: this.state.DOB,
          },
          create_date: new Date(),
          archived: {
            status: false,
          },
          type: "admin",
          password: localStorage.getItem('password')
        }
        
        data.organization = {
          name: values.org_name,
          description: "Please add org description",
          email: this.state.admin_email,
          phone: values.AH_phone,
          address: orgAddress ==! "" ? orgAddress : `${values.AH_address} ${values.AH_city} ${values.AH_province} ${values.AH_country} ${values.AH_postal}`,
          logo: "",
          payment_credentials: {},
          merch:  [
            {
              "name" : "Add Merch",
              "logo" : "tshirt.svg",
              "size" : [ "YM", "YL", "AS", "AM", "AL", "AXL" ]
            },
            {
              "name" : "Add Merch",
              "logo" : "tshirt.svg",
              "size" : [ "YM", "YL", "AS", "AM", "AL", "AXL" ]
            },
            {
              "name" : "Add Merch",
              "logo" : "tshirt.svg",
              "size" : [ "YM", "YL", "AS", "AM", "AL", "AXL" ]
            }
          ],
          waiver: "Please add a waiver",
          archived: {
            status: false
          },
          enrolment_emails: "customerservice@hoopstir.com",
          travel_waiver: "Please add a travel waiver",
          social: {
            website: values.org_website,
            instagram: values.org_instagram,
            facebook: values.org_fb,
          }
        }
        console.log('EF2 data for new hoopstir customer?', data)
      }
    }
  
    console.log('create data', data)
    data.status = 'unverified'
    if(typeof this.state.onTxnUnverified === "function") {
      this.state.onTxnUnverified();
    }
    console.log('JSON:', JSON.stringify(data))
    var rthis = this
    $.ajax({
      url: `${end_point('organizations')}/organizations/leagues`,
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: function (data) {
        if(data.errorMessage){
          alert(data.errorMessage);
        } else {
          console.log('SUCCESS: create league org', data)
          if (EF1) {
            rthis.setState({
              displayPaymentForm: true,
              showPricingBreakdown: true,
              continue_spinner: false,
              EF1Submitted: true
            })
          } else {
            var transaction_id = data.responseTransaction._id
            var organization = data.responseOrg
            localStorage.setItem('organization_id', data.responseOrg._id)
            localStorage.removeItem('password')
            // set current user from response user for enrol more teams
            if (!rthis.state.EF1) {
              var user = data.responseUser.club ? data.responseUser.club : rthis.state.current_user
  
              if (rthis.state.pricingBreakdown.total === 0) {
                rthis.requestToken(transaction_id)
              } else {
                console.log('do we have transaction id?', transaction_id)
                if(!rthis.state.token){
                  rthis.requestToken(transaction_id)
                }
                rthis.setState({
                  transaction_id,
                  displayPaymentForm: true,
                  confirm_spinner: false
                })
              }
  
              rthis.setState({
                organization,
                current_user: user
              })
  
            } else {
              rthis.setState({
                displayPaymentForm: true,
                confirm_spinner: false,
                paymentStatus: 'approved'
              })
            }
          }
        }
      },
      error: function (err) {
        alert('please contact support')
        console.log('Error at createOrg:', err)
        // TAKE THIS OUT AFTER - JUST TO MAKE IT EASIER FOR TESTING
        rthis.setState({ confirm_spinner: false })
      }
    })
  }

  displayPaymentForm = (values) => {
    const { pricingBreakdown } = this.state
    console.log(' in displayPaymentForm', values)
    if(this.state.waitlistTransaction && window.confirm(`To complete the enrolment and register your league you will pay $${pricingBreakdown.total}.  Press OK to begin your payment.`)){
      this.setState({ disabled: true, confirm_spinner: true})
      var transaction_id = this.state.transaction_id
      var rthis = this
      $.ajax({
        url: this.state.transactionEndpoint,
        type: 'GET',
        headers: {
        "token": this.state.token,
        "program_id": this.state.waitlistTransaction.program._id,
        "organization_id": this.state.organization_id,
        "enrolment_flex": true
        },
        contentType: 'application/json',
        success: function (data) {
          if (data && data.errMessage) {
            alert(data.errMessage)
            window.location.href = document.location.origin + "/enrollmentForm?jwt=" + rthis.state.token + "&organization_id=" + rthis.state.organization_id
            } else {
            if (pricingBreakdown.total === 0) {
              var response = total0Recept()
              console.log('displayPaymentForm = transactionid for total = 0', transaction_id)
              rthis.patchReceipt(transaction_id, response)
            } else {
              rthis.setState({ displayPaymentForm: true, confirm_spinner: false })
            }
          }
        },
        error: function (data){
          alert('Error connecting server, please contact support!')
          rthis.setState({ confirm_spinner: false })
        }
      })
    } else if (window.confirm(`Your total is $${pricingBreakdown.total % 1 === 0 ? pricingBreakdown.total : pricingBreakdown.total.toFixed(2)}. Press OK to confirm and proceed to payment`)) {
      this.setState({ disabled: true, confirm_spinner: true})
  
      this.createData(values)
      
    }
  }

  handleRefresh = () => {
    window.location.href = document.location.origin + "/leagueEnrolment?jwt=" + this.state.token + "&organization_id=" + this.state.organization_id
  }

  onInstalmentClick = (e) => {
    this.setState({ instalment_number: +e.target.value, showPricingBreakdown:false })
  }

  generateConvergeToken = (callback) => {
    if(this.state.waitlistInitialSignup){//  initial waitlist enrolment does not require converge token
      callback(true, null)
    } else {
      const { tokenGenerator, organization_id } = this.state
      var rthis = this;
      $.ajax({
        method: 'POST',
        dataType: "text",
        url: `${tokenGenerator}/${organization_id}`,
        success: (results) => {
          console.log('results from convergeToken', results)
          rthis.setState({ convergeToken: results }, () => console.log("TOKEN=", rthis.state.convergeToken))
          callback(true, null)
        },
        error: (err) => {
          callback(null, {"message": 'Payment token error, please try again'})
        }
      })
    }
  }

  getPrice = (fields) => {
    const {pricingEndpoint, instalment_number, selected_leagues, selected_plan, teams } = this.state
    if (this.state.EF1) {
      console.log('in EF1 getPrice')
      this.setState({ 
        pricingBreakdown: {}, 
        showPricingBreakdown: true, 
        continue_spinner: false,
      })
    } else {
      var league = selected_leagues.slice(-1)[0]
      console.log('in getPrice', selected_leagues.slice(-1)[0])
      this.setState({continue_spinner: true})
      this.generateConvergeToken((token, err) => {
        if(err) {
          alert(err.message)
          this.setState({ continue_spinner: false });
        } else {
          var data = {
            item_0: false,
            item_1: false,
            item_2: false,
            program_id: league._id,
            instalment_number: instalment_number,
            plan_id: selected_plan[league._id]._id,
            teams: teams[league._id].length,
            promo_code_key: fields.promo_code
          }
          //console.log('data to send to pricing endpoint', data)
          $.ajax({
            dataType: "json",
            url: pricingEndpoint,
            data: data,
            success: (results) => {
              var breakdown = this.state.pricingBreakdown
              breakdown[league._id] = results.message
              // console.log('what is the results', results.message, JSON.stringify(results.message))
              this.setState({ 
                pricingBreakdown: breakdown, 
                showPricingBreakdown: true, 
                continue_spinner: false,
                dataReserve: data,
              })
            },
            error: (err) => {
              alert('Unable to receive pricing, please email support@hoopstir.com.')
            }
          })
        }
      })
    }
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  uploadFile = (type, setFieldValue) => {
    var fileToAdd = document.getElementById(type).files[0]
    var attachmentSizes = 0
    this.state.attachments.forEach(file => {
      attachmentSizes += file.size
    })
    attachmentSizes +=  fileToAdd ? fileToAdd.size : 0
    console.log("ileToAdd:\n", fileToAdd)

    if(fileToAdd && fileToAdd.size > 5242880){ 
      // 5MB - AWS SES mail size limit is 10MB but lambda payload is 6MB
      alert("The image size should be smaller than 5MB!");
      document.getElementById(type).value = "";
    } else if (attachmentSizes > 5242880){
      alert("You have exceeded the limit for all attachments");
      document.getElementById(type).value = "";
    } else {
      var attachments = this.state.attachments.slice()
      setFieldValue(type, fileToAdd)
      attachments.push(fileToAdd)
      this.setState({ attachments })
    }
  }

  selectOverridenProgram = (formikProps) => {
    setTimeout(() => {
      this.leagueSelectHandler(this.state.overrideSelectedProgram, formikProps);
    }, 1);
    return true;
  }

  render() {
    const { waitlistTransaction, selected_leagues, instalments, disabled, enrolInLeagues, instalment_number, EF1, token, organization_id, organization_name, leagueOptions, showDetails, priceTotal, priceElements, pricingBreakdown, multipleLeagues, checkFormik, selected_plan, showPricingBreakdown, continue_spinner } = this.state

    var selectedLeague = selected_leagues.slice(-1)[0] ? selected_leagues.slice(-1)[0] : null
    var rthis = this;
    var league_details = [];
    if (selectedLeague) {
      var division = selectedLeague.division.charAt(0).toUpperCase() + selectedLeague.division.slice(1);
      if(selectedLeague.division === "co-ed"){
        division = "Co-Ed";
      }
      var sessions = []
      sortProgramSessions(selectedLeague.sessions).forEach((session, i) => {
        sessions.push(
          <tr key={makeUniqueKey()}>
            <td style={{ width: '20%'}} key={makeUniqueKey()}>{formatSessionDateLabel(session)}</td>
            <td style={{ width: '15%'}} key={makeUniqueKey()}>{session.start_time}</td>
            <td style={{ width: '15%'}} key={makeUniqueKey()}>{session.end_time}</td>
            <td style={{ width: '25%'}} key={makeUniqueKey()}>{session.type}</td>            
            <td style={{ width: '56%'}} key={makeUniqueKey()}>{session.location}</td>
          </tr>)
      })
      var status = selectedLeague.status === 'waitlist'? 'WAITLIST OPEN': 'OPEN'
    }
    
    league_details.push(
      <ProgramDetails 
        key="programDetails"
        EF1={EF1}
        selected_program={enrolInLeagues ? selectedLeague : null}
        division={EF1 ? null : division}
        status={ EF1 ? null : status}
        sessions={enrolInLeagues ? sessions : null}
      />
    )

    var plans = [];
    if (selectedLeague) {
      if (waitlistTransaction) {
        plans.push(<option key={waitlistTransaction.plan._id} value={waitlistTransaction.plan._id} selected>{waitlistTransaction.plan.name} - ${waitlistTransaction.price_breakdown.plan_price} {instalments.length !==0? '*monthly instalment available': ''}</option>)
      } else {
        selectedLeague.plans.forEach(plan => {
          plans.push(<option key={plan._id} value={plan._id}>{plan.plan_name} - ${plan.plan_price} {plan.instalments && plan.instalments.length !==0? '*monthly instalment available':''}</option>)
        })
      }
    } else if (EF1) {
      plans.push(<option key='free' value='0'>Free - $0</option>)
    }

    var promotion_code_field = [];
    if (Object.keys(selected_plan).length !== 0) {
      if(waitlistTransaction){
        promotion_code_field.push(
          <Col key={makeUniqueKey()} className="form-group" onKeyUp={()=>{this.setState({showPricingBreakdown: false})}}>
            <ControlLabel>Discount Code</ControlLabel>
            <Field 
              name="promo_code" 
              id="promotion_code" 
              className="opaque-grey form-control" 
              disabled={disabled} 
              />
          </Col>
        )
      } else {
        promotion_code_field.push(
          <Col key={makeUniqueKey()} className="form-group" onKeyUp={()=>{this.setState({showPricingBreakdown: false})}}>
            <ControlLabel>Discount Code</ControlLabel>
            <Field 
              name="promo_code" 
              id="promotion_code" 
              className="opaque-grey form-control" 
              disabled={disabled} 
              />
          </Col>
        )
      }
    }

    var elements = priceElements
    var leaguesTotal = priceTotal
    var submission = [];
    if (this.state.showPricingBreakdown && !EF1) {
      var elements = this.state.priceElements
      var leaguePriceElements = []
      
      var leagueTotal = 0
      this.state.teams[selectedLeague._id].forEach(team => {
        if (pricingBreakdown[selectedLeague._id].extra_fees) {
          var fees = pricingBreakdown[selectedLeague._id].extra_fees
          var extraFees = []
          fees.forEach(fee => {
            for (var extra in fee) {
              extraFees.push(
                <tr>
                  <td style={{width: "80%"}}>{extra.split('_').join(' ')}</td>
                  <td className="price-element">${fee[extra]}</td>
                </tr>
                )
            }
            
          })
        }
        leaguePriceElements.push(
          <Fragment>
            <tr key={makeUniqueKey()}>
              <td style={{width: "80%"}}>- {selected_plan[selectedLeague._id].plan_name}: {team.name}</td>
              <td className="price-element">${selected_plan[selectedLeague._id].plan_price}</td>
            </tr>
            {extraFees}
          </Fragment>
        )
      })

      if (pricingBreakdown[selectedLeague._id].membership_fee && pricingBreakdown[selectedLeague._id].membership_fee !== 0 ){
        leaguePriceElements.push(
        <tr key={makeUniqueKey()}>
          <td style={{width: "80%"}}>Membership fee</td>
          <td className="price-element">${pricingBreakdown[selectedLeague._id].membership_fee}</td>
        </tr>)
      }

      if (pricingBreakdown[selectedLeague._id].early_bird_applied) {
        leaguePriceElements.push(
          <tr key={makeUniqueKey()}>
            <td style={{width: "80%"}}>Early Bird Discount</td>
            <td className="price-element">{pricingBreakdown[selectedLeague._id].early_bird}</td>
          </tr>)
      }

      if (document.getElementById("promotion_code").value){
        leaguePriceElements.push(
        <tr>
          <td style={{width: "80%"}}>Promotion Code Discount</td>
          <td className="price-element">{pricingBreakdown[selectedLeague._id].promo_code}</td>
        </tr>)
      }

      if (multipleLeagues) {
        leaguesTotal+= leagueTotal
        this.setState({ 
          priceElements: elements, 
          priceTotal: leaguesTotal, 
          multipleLeagues:false
        })
      }
      var PBTotal = 0
      for (var league in pricingBreakdown) {
        if (pricingBreakdown[league].plan_price) {
          PBTotal += pricingBreakdown[league].total
        }
      }

      pricingBreakdown.total = PBTotal
      
      elements[selectedLeague._id] = leaguePriceElements
      
      submission.push(
        <PriceBreakdown
          key={makeUniqueKey()}
          leagueOptions={leagueOptions.length}
          enrolInMoreLeagues={this.enrolInMoreLeagues}
          selected_program={selected_leagues}
          FormikValues={this.state.FormikValues}
          pricingBreakdown={pricingBreakdown}
          displayPaymentForm={this.state.displayPaymentForm}
          confirm_spinner={this.state.confirm_spinner}
          displayPaymentFormFn={this.displayPaymentForm}
          priceElements={this.state.priceElements}
          instalment_number={this.state.instalment_number}
          disabled={this.state.disabled}
          instalment_number={instalment_number}
        />
      )
    } else {
      enrolInLeagues ? 
        submission.push(
          <Fragment>
          { continue_spinner ? 
            <div className="enrolment-loader"></div> 
            :
            <Col sm={3} style={{paddingLeft: '0'}}>
              <Button 
                className="button2" 
                type="submit" 
                onClick={(e) => this.checkSavedTeams(e)}
                disabled={!selectedLeague || this.state.teams[selectedLeague._id].length === 0}>Continue</Button>
            </Col>
          }
        </Fragment>
        )
      :
        submission.push(
        <Col key="ef1-submit-column" sm={3} style={{ padding: '0' }}>
          { continue_spinner ? <div className="enrolment-loader"></div> : <Button className="button2" type="submit">Submit</Button> }
        </Col>
        )
    }

    let payment_field = this.state.gateway === "stripe" ? 
    <StripePaymentGateway  
      currencyType={this.state.currencyType} 
      pricingBreakdown={this.state.pricingBreakdown}
      patchReceipt={this.patchReceipt}
      paymentStatus={this.state.paymentStatus}
      pay_spinner={this.state.pay_spinner}
      setSpinner={this.setSpinner}
      selected_program={this.state.selected_program} 
      pay={this.pay}
      email={this.state.parent_email}
      name={this.state.name}
      handleRefresh={this.state.overrideHandleRefresh ? this.state.overrideHandleRefresh : this.handleRefresh}
      handleApprovedSignOut={this.handleApprovedSignOut}
      handleApprovedRedirect={this.handleApprovedRedirect} 
      stripeEndPoint={this.state.stripeEndPoint}
      stripeDecline={this.stripeDecline}
    />
    :
    <ConvergePaymentGateway
      existing={token ? true : false }
      email={this.props.email}
      handleSignIn={this.handleSignIn}
      handleRefresh={this.state.overrideHandleRefresh ? this.state.overrideHandleRefresh : this.handleRefresh}
      handleApprovedSignOut={this.handleApprovedSignOut}
      handleApprovedRedirect={this.handleApprovedRedirect}  
      paymentStatus={this.state.paymentStatus}
      pay_spinner={this.state.pay_spinner}
      selected_program={this.state.selected_program} 
      pay={this.pay}
      enrolInMoreLeagues={this.state.overrideHandleRefresh ? this.state.overrideHandleRefresh : this.enrolInMoreLeagues}
      league={true}
      EF1={EF1}
    />

    if (selectedLeague) {
      var planSet = !(plans.length === 1) && selected_plan[selectedLeague._id] === null
    }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={ (fields, props) => {
        console.log("on Submit field values:", fields)
        if (EF1) {
          this.createData(fields)
        } else {
          this.getPrice(fields)
        }
        this.setState({ FormikValues: fields })
      }}

      render={props => (
        <div style={{height:"100%"}}>
        {
          this.props.allowSelectPrograms ? (
          token ? <HamburgerNavbar organization_id={organization_id} token={token} league={true}/> : <OrganizationBar organization_id={organization_id} organization_name={organization_name}/>
          ): ""
        }
        <div className="body-wrapper" style={{ overflow: 'auto'}}>
          <Form>
          <Col sm={12}>
            {this.props.allowSelectPrograms ? (
              <Row>
              <Col sm={5}>
                <ControlLabel className="white-text mobile-title-1 control-lbl">
                  <img src="1.png" alt="no. step" className="num-icon half"/>&nbsp; 
                  {enrolInLeagues ? '': ''}
                </ControlLabel>
                {
                  window.matchMedia("(max-width: 750px)").matches && navigator.platform !== "iPhone"?
                  <div className="dashboard-box test-container" style={{overflow: "auto"}}>
                    <div className="opaque-grey options-list test-box" type="select" id="selected_program" onClick={(e) => this.leagueSelectHandler(e, props)} onChange={(e) => this.leagueSelectHandler(e, props)} disabled={disabled}>
                      {leagueOptions}
                    </div>
                  </div>
                  :
                  (window.matchMedia("(max-width: 750px)").matches && navigator.platform === "iPhone") ?
                  <div className="dashboard-box ios-select" style={{overflow: "auto"}}>
                    <div className="opaque-grey options-list" disabled={disabled}>
                    {leagueOptions}
                    </div>
                  </div>
                  :
                  <div className="dashboard-box" style={{overflow: "auto"}}>
                    <FormControl className="opaque-grey options-list" id="selected_league" onChange={(e) => this.leagueSelectHandler(e, props)} componentClass="select" size={4} disabled={disabled}>
                      {leagueOptions}
                    </FormControl>
                  </div>
                }
              </Col>
              { showDetails || EF1 ? (
                  <Col sm={7} style={{ paddingTop: "35px"}} >
                    <div className="dashboard-box" style={{ marginBottom: "3%"}}>
                      <div className="white-text program-details" id="program-details">
                        {league_details}
                      </div>
                    </div>
                  </Col>
                ) : "" }
            </Row>

              ): ""}
              { showDetails || EF1 || (this.state.overrideShowDetails && this.selectOverridenProgram(props)) ? (
                <div className="enrolment-box">
                { !EF1 &&
                  <Row>
                        <h2>
                          <img 
                            className="num-icon half"
                            src="1.png"
                            alt="no. step"
                          />
                          Pricing
                        </h2>
                      <Row className="enrolment-row">
                          <Col lg={6}>
                            <ControlLabel>
                              {enrolInLeagues ? 'Price Plan' : 'Select the Hoopstir Pricing Plan' }
                            </ControlLabel>

                            <Field 
                              name="selected_plan" 
                              id="selected_plan" 
                              className="opaque-grey form-control" 
                              component="select" 
                              disabled={disabled}
                              onChange={(e) => this.planSelectHandler(e.target.value, props.setFieldValue)}>
                                <option 
                                  value="" 
                                  key="plan-select" 
                                  //selected={!(plans.length === 1) && selected_plan[selectedLeague._id] === null} 
                                  selected={planSet}
                                  disabled>
                                    Select...
                                </option>
                                {plans}
                            </Field>
                            <ErrorMessage 
                              component="div" 
                              name="selected_plan"  
                              className="invalid-feedback"
                            />
                          </Col>

                          <Col lg={3}>
                              {promotion_code_field}
                          </Col>
                      </Row>

                      <Row className="enrolment-row">
                        { instalments.length !== 0 && 
                          instalment_field(
                            instalments,
                            instalment_number,
                            selectedLeague,
                            selected_plan[selectedLeague._id]._id,
                            disabled,
                            this.onInstalmentClick
                          )}
                      </Row>

                  </Row>
                  }

                  {!token || EF1 ? // - FOR CLUBS THAT ARE NOT EXISTING HOOPSTIR CUSTOMERS
                  <div onKeyDown={()=>{this.setState({showPricingBreakdown: false})}}>
                    <Row>
                      <AccountHolderDetails 
                      handleAHDetails={this.handleAHDetails} 
                      DOB={this.state.DOB} 
                      values={props.values} 
                      email={this.state.admin_email} 
                      setFieldValue={props.setFieldValue} 
                      handleDate={this.handleDate} 
                      disabled={disabled}
                      EF1={EF1}/>
                    </Row>
                    <Row>
                      <OrgDetails 
                        enrolInLeagues={enrolInLeagues} 
                        handleOrgDetails={this.handleOrgDetails} 
                        setFieldValue={props.setFieldValue} 
                        disabled={disabled} 
                        uploadFile={this.uploadFile} 
                        EF1={EF1}/>
                    </Row>
                  </div>
                  : ""
                  }

                  {enrolInLeagues ?
                    <div className="white-text" disabled={disabled}>
                      <Row className="enrolment-row" >
                        {this.renderTeams(props.setFieldValue)}
                      </Row>
                      <ErrorMessage component="div" name="teams" className="invalid-feedback"/>
                    </div>
                    :
                    <Row>
                      <PaymentDetails disabled={disabled}/>
                    </Row>
                  }

                  {
                    EF1 ? "" :
                    <Row className="terms-row">
                    <Field name="agree_waver" id="agree_waver" type="checkbox" disabled={disabled}/>
                    <a className="white-text orange-hover" style={{paddingLeft: '0.5em'}} onClick={this.handleWaiverModal}>
                      I have read the <span style={{textDecoration: 'underline'}}>waiver</span> for {selectedLeague ? selectedLeague.group_name: 'Hoopstir'}
                    </a>
                    {
                      props.values.agree_waver === false ? 
                      <div className="invalid-feedback">Please read Waiver to continue</div>
                      :
                      <ErrorMessage component="div" name="agree_waver" className="invalid-feedback"/>
                    }
                  </Row>
                  }

                  <Row className="enrolment-row">

                  <div>
                      {
                        props.isValid === false && checkFormik === true &&
                        this.checkEmptyFields()
                      }
                      { this.state.EF1Submitted ? <Col sm={3}></Col> : submission}
                      {this.state.displayPaymentForm && this.state.showPricingBreakdown ? payment_field: ""}
                  </div> 

                  </Row>
              </div>
              ): ""
            }
            </Col>

          </Form>
          <Modal dialogClassName="wide-modal white-text" show={this.state.showWaiverModal} onHide={this.handleWaiverModal}>
            <Modal.Body>
              <Row>
                <Col sm={2} className="pull-right" style={{textAlign: "right"}}>
                  <a onClick={() => this.setState({showWaiverModal: false})}>
                    <FontAwesomeIcon icon={faTimes} size="1x" color='white'/>
                  </a>
                </Col>
              </Row>
              <Row>
                <h3 style={{paddingLeft: "2%"}}>Terms</h3>
                <div style={{whiteSpace: "pre-wrap", padding: "2%"}}>
                  {selectedLeague ? selectedLeague.waiver : "" }
                </div>
              </Row>
              <div> &nbsp;</div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
      )}
    />
    )
  }
}


export default LeagueEnrolment
